import { app } from "@/modules/app";
import { useStackRouteComponent } from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
  {
    parent: "public",
    path: "/push-subscribe",
    component: useStackRouteComponent(
        () => import("@/modules/push/components/PushNotificationSubscribe.dialog.vue")
    ),
    meta: {
      title: "Подписка на уведомления",
    },
  },
]);

